import { 
    IMutations,
    IMutationsFinancialReportPayload
} from './mutations.types'
import { IFinancialReport, INotification, IFinancialReportData } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    
    /** refresh the state with application header info */
    setFinancialReport(state: IFinancialReportData, payload: IMutationsFinancialReportPayload): void {
        if(!payload.report.WorkflowInfo) {
            payload.report.WorkflowInfo = state.selectedReport.WorkflowInfo
        }
        state.selectedReport = payload.report;
    },

    setGrant(state: IFinancialReportData, payload: any) {
        state.grantInfo = payload.meta;
        state.grantData = payload.data;
        state.documentTags = payload.docCategories.tags;
        state.documentCategories = payload.docCategories.categories;
        state.categories = payload.categories;
        state.finReports = payload.financialReports;
        state.requestedAuditDocs = payload.requestedAuditDocs;
    },

    setAppBudgetForGrant(state: IFinancialReportData, payload: any) {
        state.applicationBudgetForGrant = payload.applicationBudget;
    },

    setTemplate(state: IFinancialReportData, payload: any) {
        state.finReportTemplate = payload.template[state.language];
        // if(!state.selectedKey && state.finReportTemplate && state.finReportTemplate.properties) {
        //     state.selectedKey = Object.keys(state.finReportTemplate.properties)[0];
        // }
    },

    refreshModel(state: IFinancialReportData, payload: any) {
        state.grantData = payload.report;
    },

    setCurrency(state: IFinancialReportData, payload: any) {
        state.currencyList = payload;
    },

    setForecastTemplate(state: IFinancialReportData, payload: any) {
        state.forecastTemplate = payload[state.language];
    },

    updateSelectedKey(state: IFinancialReportData, payload: any) {
        state.selectedKey = payload;
    },

    updateAuditDocs(state: IFinancialReportData, payload: any) {
        if (payload) {
            let record = state.requestedAuditDocs.find((x) => x.id == payload.id);

            if (record) {
                state.requestedAuditDocs.map((x) => {
                    if (x.id == payload.id) {
                        x.records = payload.records;
                    }
                });
            } else {
                state.requestedAuditDocs.push(payload);
            }
        }
    }

}